module.exports = __webpack_public_path__ + "static/media/belle-lose.22b3d6c6.png";